/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cash-stack': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M1 0a1 1 0 00-1 1v10a1 1 0 001 1h18a1 1 0 001-1V1a1 1 0 00-1-1H1zm1.912 2h14.176a1.5 1.5 0 00.912.912v6.176a1.5 1.5 0 00-.912.912H2.912A1.5 1.5 0 002 9.088V2.912A1.5 1.5 0 002.912 2zM10 3a3 3 0 100 6 3 3 0 000-6zM5 5a1 1 0 100 2 1 1 0 000-2zm10 0a1 1 0 100 2 1 1 0 000-2zM0 13v2h20v-2H0zm0 3v2h20v-2H0z" _fill="currentColor"/>'
  }
})
